import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { GridToolbarQuickFilter } from "@mui/x-data-grid-pro";

const QuickFilter = () => {
    return (
        <GridToolbarQuickFilter
            id="gridInSearch"
            variant="outlined"
            sx={{
                p: 0,
                "& .MuiInputBase-input": {
                    p: 1,
                },
            }}
            InputProps={{
                startAdornment: null,
                endAdornment: <SearchIcon fontSize="small" />,
            }}
        />
    );
};

export default QuickFilter;
